class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') this.setAttribute('data-dd-keyboard-open', '');
    });
    this.detailsContainer.addEventListener('pointerdown', () => this.removeAttribute('data-dd-keyboard-open'));
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.classList.contains('header__search')) {
      const searchSurface = this.querySelector('.dd-search');

      if (this.summaryToggle.contains(event.target)) return;

      if (searchSurface && !searchSurface.contains(event.target)) {
        const clickedFocusable = event.target.closest(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        const shouldReturnFocus = !clickedFocusable;
        this.close(shouldReturnFocus);
      }
      return;
    }

    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    const isHeaderSearch = this.classList.contains('header__search');

    if (isHeaderSearch) {
      document.querySelectorAll('#Details-HeaderMenu-DD-Shop[open]').forEach((details) => {
        const megaMenu = details.querySelector('dd-mega-menu');
        if (typeof megaMenu?.close === 'function') megaMenu.close(false);
        else details.removeAttribute('open');
      });

      const mobileMenu = document.querySelector('header-drawer');
      if (mobileMenu?.mainDetailsToggle?.hasAttribute('open')) {
        const mobileMenuToggle = mobileMenu.mainDetailsToggle.querySelector('summary');
        mobileMenu.closeMenuDrawer(null, mobileMenuToggle);
        mobileMenu.mainDetailsToggle.removeAttribute('open');
      }

      this.lockSearchViewport();
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.toggleAttribute('data-dd-keyboard-open', event?.detail === 0);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.addEventListener('keydown', this.onDocumentKeyDown, true);
    document.body.classList.add('overflow-hidden');
    this.updateSearchPosition();
    this.onResizeEvent = this.onResizeEvent || this.updateSearchPosition.bind(this);
    window.addEventListener('resize', this.onResizeEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    window.requestAnimationFrame(() => this.querySelector('predictive-search')?.onFocus());
  }

  onDocumentKeyDown = (event) => {
    if (event.code.toUpperCase() !== 'ESCAPE' || !this.isOpen()) return;
    event.preventDefault();
    event.stopPropagation();
    this.close();
  };

  lockSearchViewport() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    this.searchScrollY = window.scrollY;
    document.documentElement.style.setProperty('--dd-search-scroll-lock-offset', `${-this.searchScrollY}px`);
    document.documentElement.classList.add('dd-search-open');
  }

  unlockSearchViewport() {
    if (this.searchScrollY === undefined) return;

    const scrollY = this.searchScrollY;
    this.searchScrollY = undefined;
    document.documentElement.classList.remove('dd-search-open');
    document.documentElement.style.removeProperty('--dd-search-scroll-lock-offset');
    window.scrollTo(0, scrollY);
  }

  updateSearchPosition() {
    const searchModal = this.querySelector('.search-modal');
    const headerSection = this.closest('.section-header');
    if (!searchModal || !headerSection) return;
    const visibleStickyHeader = headerSection.classList.contains('shopify-section-header-sticky')
      && !headerSection.classList.contains('shopify-section-header-hidden');
    const publishedHeight = Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--dd-header-visible-height')
    );
    const headerBottom = visibleStickyHeader && Number.isFinite(publishedHeight)
      ? publishedHeight
      : headerSection.getBoundingClientRect().bottom;
    searchModal.style.setProperty('--dd-search-top', `${Math.max(0, headerBottom)}px`);
  }

  close(focusToggle = true) {
    this.querySelector('predictive-search')?.close();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.removeAttribute('data-dd-keyboard-open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.removeEventListener('keydown', this.onDocumentKeyDown, true);
    window.removeEventListener('resize', this.onResizeEvent);
    document.body.classList.remove('overflow-hidden');
    this.unlockSearchViewport();
  }
}

customElements.define('details-modal', DetailsModal);
